import type { ConstValues } from './helpers.ts';

export const bqJobStatus = {
  Error: 'error',
  InProgress: 'in progress',
  Running: 'running',
  Ready: 'ready',
  Loading: 'loading',
} as const;
export type BqJobStatus = ConstValues<typeof bqJobStatus>;

export type BqJobResponseApi<T> = {
  status: BqJobStatus | string;
  job_id?: string;
  output?: T;
  msg?: string;
};
